import React from 'react';
import MuiTextField from '@material-ui/core/TextField';
import styled from 'styled-components/macro';

const getVariants = variant => {
  switch (variant) {
    case 'form-builder':
      return '';
    case 'inline':
      return '& > div {padding: 0.4rem !important;}';
    default:
      return '';
  }
};

const TextField = styled(MuiTextField)`
  && {
    width: 100%;
  }

  [class*='MuiInputBase-root'] {
    padding: 0.8em;
    border-radius: 6px;
    background: #fff;
    ${({ $multiline }) =>
      $multiline ? '' : ' max-height: 37px;'} // match select cmp height
    font-size: 14px;
    transition: 0.2s;
  }

  input {
    padding: 0;
    font-size: 14px;
  }

  ${({ $variant }) => getVariants($variant)}

  ${({ $customCSS }) => $customCSS}
`;

const WannaBeInput = styled.div`
  background: #fff;
  border-color: rgba(0, 0, 0, 0.23);
  border-style: solid;
  border-width: 1px;
  font-size: 14px;
  padding: 0.5em 0.8em;
  border-radius: 6px;
  cursor: text;
  line-height: 1.1875em;

  ${({ $multiline }) =>
    $multiline
      ? ' min-height: 79px;'
      : ' min-height: 37px;'} // match select cmp height



  &:hover {
    border-color: #000;
  }

  ${({ $variant }) => getVariants($variant)}

  ${({ $customCSS }) => $customCSS}
`;

const muiVariants = ['standard', 'outlined', 'filled'];
const variantAlias = {
  inline: 'standard'
};

const InputBase = ({
  customCSS = '',
  variant: givenVariant = '',
  ...props
}) => {
  const variant = variantAlias[givenVariant] || givenVariant;
  let defaultVariant = 'outlined';
  // console.log('variantAlias', variantAlias);
  if (muiVariants.includes(variant)) {
    defaultVariant = variant;
  }

  return (
    <TextField
      $customCSS={customCSS}
      $multiline={props.multiline}
      $variant={givenVariant}
      variant={defaultVariant}
      {...props}
    />
  );
};

/**
 * This is a div that mocks the InputBase component, it doesn't trigger onBlur
 * and ment to be in use to display clickable links in inputs only. Avoid using this component
 * for any other purpose!
 * @param {*} props - props to pass on to the div
 */
export const MockInput = ({ customCSS = '', variant, ...props }) => {
  return (
    <WannaBeInput
      $customCSS={customCSS}
      $multiline={props.multiline}
      $variant={variant}
      {...props}
    />
  );
};

export default InputBase;
